export const SUCCESS = 1;
// export const MERCHANT_CODE = 106589;